import { toHref } from '@peloton/external-links/models';
import { getExtLinkEnv } from '@peloton/external-links/redux';
import { myMembershipAccount } from '@peloton/links/account';
import { useReduxState } from '@engage/redux/hooks';

export const useUpgradeMembershipPath = () => {
  const linkEnv = useReduxState(getExtLinkEnv);

  return toHref(myMembershipAccount, linkEnv);
};
